module.exports = __webpack_public_path__ + "img/方膜白底.8dda2d93.jpg";